import React, { useEffect } from 'react';
import './AppHeader.scss';
import { ApplicationState } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import '../theme/common.scss';
import * as headerFooterStore from '../store/HeaderFooterStore';
import { bindActionCreators } from 'redux'

interface AppHeaderProps { }

const HistoryListener: React.FC<AppHeaderProps> = () => {
    let location = useLocation();
    const locationState = useSelector((state: ApplicationState) => state.location);
    const boundSetPage = bindActionCreators(headerFooterStore.actionCreators.setPage, useDispatch());

    // Set up a listener to notify the HeaderFooter store when the page changes
    useEffect(() => {
        boundSetPage(location.pathname, locationState?.selectedChannel?.channelType);
        //console.log("Changing HL page to = " + location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
    return (<div></div>);
};

export default HistoryListener;
